import React from 'react'

function Footer() {
    return (
        <div className="flex" style={{display: "flex", flexDirection: "row", zIndex: "1", position: "absolute", color:"red" }}>
           <span> &#xA9; soumikdas 2021 </span> 
        </div>
    )
}

export default Footer


